import React from 'react';
import { ConfigProvider, DatePicker, Space } from 'antd';
import { Controller, Control } from 'react-hook-form';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material';

const { RangePicker } = DatePicker;

interface DateRangePickerProps {
  name: string;
  control: Control<any>;
  defaultValue?: string;
}

export default function DateRangePicker({ name, control, defaultValue }: DateRangePickerProps) {
  const theme = useTheme();
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: theme.palette.primary.light
        }
      }}
    >
      <Space direction='vertical' className='w-full'>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <RangePicker
              format='YYYY-MM-DD'
              {...field}
              value={field.value ? [dayjs(field.value.split(',')[0]), dayjs(field.value.split(',')[1])] : null}
              onChange={(dates) => {
                // Send the dates as a comma-separated string
                const formattedDates = dates
                  ? `${dates[0]?.format('YYYY-MM-DD')},${dates[1]?.format('YYYY-MM-DD')}`
                  : '';
                field.onChange(formattedDates);
              }}
              size='large'
              className='w-full'
            />
          )}
        />
      </Space>
    </ConfigProvider>
  );
}
